var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as cn from "classnames";
import * as React from "react";
import ListItemNews from "backpack-ui/dist/components/listItemNews";
import ListContainer from "../../components/listContainer";
var NewsList = function (_a) {
    var adSlot = _a.adSlot, newsItems = _a.newsItems, styleOverride = _a.styleOverride;
    return (React.createElement(ListContainer, { className: cn("NewsList"), adSlot: adSlot, items: newsItems.map(function (item, index) { return (React.createElement(ListItemNews, __assign({ key: index }, item))); }), styleOverride: styleOverride }));
};
export default NewsList;



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/newsList/index.tsx
// module id = rPhA
// module chunks = 3